<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-12">
                            <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                                <template slot="Filtros">
                                    <div class="col-auto">
                                        <label class="col-form-label text-primary">Por</label>
                                    </div>
                                    <div class="col-auto">
                                        <select @change="Recuperar" v-model="Filtro.IdProductoCategoria" class="form-select form-control-search">
                                            <option value="">Todos</option>
                                            <option v-for="(item,index) in Categorias" :key="index" :value="item.IdProductoCategoria">{{item.Nombre}}</option>
                                        </select>
                                    </div>
                                </template>
                                <template slot="header">
                                    <th :class="StyleTh+' text-center'">#</th>
                                    <th :class="StyleTh">Nombre</th>
                                    <th :class="StyleTh">Costo</th>
                                    <th :class="StyleTh">Categoría Producto</th>
                                    <th :class="StyleTh">Elegir</th>
                                </template>
                                <template slot="body">
                                    <tr v-for="(lista,index) in Productos" :key="index">
                                        <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                        <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                        <td><p :class="StyleTd">{{ lista.Costo }}</p></td>
                                        <td><p :class="StyleTd">{{ lista.producto_categoria.Nombre }}</p></td>
                                        <td v-if="BndMostrarBotones" class="align-middle">
                                            <button v-show="lista.ShowButton" @click="SeleccionarProducto(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle text-primary"></i> Agregar</button>
                                        </td>
                                    </tr>
                                    <CSinRegistros :pContIF="Productos.length" :pColspan="5"></CSinRegistros>
                                </template>
                            </CList>
                        </div>
                    </div>
                </div>
            </template>
        </CLoader>
    </div>
</template>
<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name: 'FormProductos',
    props:['poBtnSave','objProductosSeleccionados','objProductosRegistrados'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            Emit: this.poBtnSave.EmitSeccion,
			masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
            ConfigList:{
                Title:'Productos',
                BtnNewShow:false,
                ShowTitleFirst: false,
                // ShowTitleEnd:   false,
                ShowLoader: false,
                ShowFooter: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                IdProductoCategoria:""
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            segurity: {},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Productos:[],
            BndMostrarBotones:false,
            Categorias:[]
        }
    },
    methods: {
        Recuperar(){
            this.ConfigList.ShowLoader=true;
            this.$http.get('productos',
            {
                params:{
                    Nombre: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdProductoCategoria:this.Filtro.IdProductoCategoria
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.Productos=res.data.data.data;
                // this.Presentaciones     = res.data.data.data;
                this.Productos.map((el)=>{return el.ShowButton=true;})
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.FiltrarBoton();
                this.ConfigList.ShowLoader = false;
                this.ConfigLoad.ShowLoader = false;
            });
        },
        SeleccionarProducto(item){
            this.bus.$emit('SeleccionarProducto',item);
        },
        FiltrarBoton(){
            this.BndMostrarBotones=false;
            if (this.objProductosRegistrados.length>0) {
                this.Productos.forEach(element => {
                    let BndCambio=this.objProductosRegistrados.some((el)=>{return el.IdProducto==element.IdProducto});
                    if (BndCambio) {
                        element.ShowButton=false;
                    }
                });
            }
            if (this.objProductosSeleccionados.length>0) {
                this.Productos.forEach(element => {
                    let BndCambio=this.objProductosSeleccionados.some((el)=>{return el.IdProducto==element.IdProducto});
                    if (BndCambio) {
                        element.ShowButton=false;
                    }
                });
            }
            this.BndMostrarBotones=true;
        },
        ListaCategorias(){
            this.$http.get("productosCategoria/simple"
            ).then((res)=>{
                this.Categorias=res.data.data;
            })
        }
    },
    created() {
        this.ListaCategorias();
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            // this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            // this.Limpiar();
            this.Recuperar();
        });
    }
}
</script>